import React from 'react';
import { SvgIcon } from '@mui/material';

function CampaignIcon({ ...props }) {
  return (
    <SvgIcon {...props} viewBox="0 0 36 43">
      <path
        d="M20.1847 43L27.1051 0.818181H31.2244L24.304 43H20.1847ZM0.988636 31.3011L1.64773 27.1818H33.1193L32.4602 31.3011H0.988636ZM5.35511 43L12.2756 0.818181H16.3949L9.47443 43H5.35511ZM3.46023 16.6364L4.11932 12.517H35.5909L34.9318 16.6364H3.46023Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default CampaignIcon;
